import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class EmailLauncherService {
  openEmail(to: string, subject = '', body = ''): void {
    const mailto = `mailto:${encodeURIComponent(to)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailto;
  }
}